/**
 * @ngdoc service
 * @name filters.dateInMiliseconds
 *
 * @description
 * Convert date in miliseconds
 *
 * @param dateParam e.g. '2018-12-29T00:00:00Z'
 */

angular.module('filters')
    .filter('dateInMiliseconds', () => (dateParam) => {

        if (!dateParam) {

            return '';

        }

        const date = new Date(dateParam);

        return parseInt(date.getTime(), 10);

    });



// WEBPACK FOOTER //
// ./scripts/filters/date-in-miliseconds.js